import React from 'react';
import { Box, Button, Container, Typography } from '@mui/material';
import Lottie from 'lottie-react';
import lottie1 from '../assets/lottie1.json';
import lottie2 from '../assets/lottie2.json';
import lottie3 from '../assets/lottie3.json';

const MintPage: React.FC = () => {
  return (
    <Container maxWidth="lg">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 4,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-around',
            width: '100%',
            flexWrap: 'wrap',
            gap: 2,
          }}
        >
          {/* First NFT */}
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
            <Box sx={{ width: 150, height: 150 }}>
              <Lottie animationData={lottie1} loop={true} />
            </Box>
            <Button variant="contained">Buy</Button>
            <Typography variant="body1">5 ton</Typography>
          </Box>

          {/* Second NFT */}
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
            <Box sx={{ width: 150, height: 150 }}>
              <Lottie animationData={lottie2} loop={true} />
            </Box>
            <Button variant="contained">Buy</Button>
            <Typography variant="body1">10 ton</Typography>
          </Box>

          {/* Third NFT */}
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
            <Box sx={{ width: 150, height: 150 }}>
              <Lottie animationData={lottie3} loop={true} />
            </Box>
            <Button variant="contained">Buy</Button>
            <Typography variant="body1">15 ton</Typography>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default MintPage; 